import React from 'react';

import { ColorsType, variables } from '../variables';

type ArrowBottomProps = {
  stroke?: ColorsType
}

export  const ArrowBottom: React.FC<ArrowBottomProps> = ({
  stroke= 'road-grey-700'
}) => {
  return (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" stroke={variables.colors[stroke]} xmlns="http://www.w3.org/2000/svg">
      <path d="M0.749024 1.21558L4.24902 4.55832L7.74902 1.21558" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
